export default {
  S1: 'S1',
  S2: 'S2',
  S3: 'S3',
  M1: 'M1',
  M2: 'M2',
  M3: 'M3'
}
